import { render, staticRenderFns } from "./GonghuoTaskDetailTab.vue?vue&type=template&id=5fc78880&scoped=true&"
import script from "./GonghuoTaskDetailTab.vue?vue&type=script&lang=js&"
export * from "./GonghuoTaskDetailTab.vue?vue&type=script&lang=js&"
import style0 from "./GonghuoTaskDetailTab.vue?vue&type=style&index=0&id=5fc78880&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc78880",
  null
  
)

export default component.exports